module.exports = __webpack_public_path__ + "img/accessory_shirt_07.46c5cb79.svg";